/* VoluFine · image + texte : soulignement et surlignage qui se dessinent à l'arrivée à l'écran (comme la source),
   bouton « Aggiungi al carrello » qui appuie sur le bouton d'achat de la fiche (Moon ajoute l'offre choisie et ouvre son panier). */
(function(){
  function init(root){
    if(!root||root.dataset.ready)return; root.dataset.ready='1';
    var hl=[].slice.call(root.querySelectorAll('[data-vf06-hl]'));
    function check(){ var vh=window.innerHeight; hl=hl.filter(function(el){ var r=el.getBoundingClientRect(); if(r.top<vh*0.92&&r.bottom>0){ el.classList.add('is-in'); return false; } return true; });
      if(!hl.length) window.removeEventListener('scroll',onS); }
    var t=null; function onS(){ if(!t)t=setTimeout(function(){ t=null; check(); },80); }
    window.addEventListener('scroll',onS,{passive:true}); setTimeout(check,200);
    [].slice.call(root.querySelectorAll('[data-vf06-buy]')).forEach(function(b){
      b.addEventListener('click',function(e){
        /* 17/10 : même règle que les boutons du bas (sv-vf-11.js) : la page remonte au bloc d'offres, puis le bouton
           d'achat principal envoie l'offre cochée (Moon met le lot entier). */
        e.preventDefault(); if(b.hasAttribute('data-busy'))return;
        var main=document.querySelector('[data-vf-add]')||document.querySelector('form[action*="/cart/add"]:not([id*="rawer"]) [name="add"]');
        if(!main)return;
        var target=document.querySelector('[data-vf-moon]')||main, wait=0;
        var y=target.getBoundingClientRect().top+window.pageYOffset-90;
        if(Math.abs(y-window.pageYOffset)>4){ window.scrollTo({top:Math.max(0,y),behavior:'smooth'}); wait=650; }
        b.setAttribute('data-busy','');
        setTimeout(function(){ main.click(); b.removeAttribute('data-busy'); },wait);
      });
    });
  }
  function all(){ [].slice.call(document.querySelectorAll('[data-vf06]')).forEach(init); }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',all); else all();
  document.addEventListener('shopify:section:load',all);
})();
